<template>
  <bread-crumb list-classes="breadcrumb-links breadcrumb-dark">
    <BreadCrumbItem>
        <router-link to="/">
          <i class="fas fa-home"></i>
        </router-link>
    </BreadCrumbItem>
    <BreadCrumbItem
      v-for="(route, index) in routeMatched"
      :key="route.name"
      :active="index === routeMatched.length - 1"
      style="display:inline-block"
    >
      <router-link v-if="index < routeMatched.length - 1" :to="route.to">
        {{ getBreadName(route) }}</router-link>
      <span v-else>{{ getBreadName(route) }}</span>
    </BreadCrumbItem>
  </bread-crumb>
</template>

<script>
  import BreadCrumb from './Breadcrumb';
  import BreadCrumbItem from './BreadcrumbItem';

  export default {
    name: 'route-breadcrumb',
    components: {
      BreadCrumb,
      BreadCrumbItem
    },
    data() {
      return {
        version: 1
      }
    },
    methods: {
      getBreadName(route) {
        return route.meta && route.meta.breadcrumbTitle || route.name;
      },
      update() {
        this.version = this.version + 1
      }
    },
    computed: {
      routeMatched() {
        let routes = this.$route.matched.slice()
        .filter(r => r.path !== '')
        .filter(r => this.getBreadName(r))
        routes = routes.filter((r, i) => i == 0 || this.getBreadName(r) !== this.getBreadName(routes[i - 1]))
        routes = routes.filter((r, i) => !routes[i + 1] || `${r.path}/` !== `${routes[i + 1].path}`)
        routes = routes.map(r => {
          if (r.params) {
            Object.keys(r.params).forEach(k => {
              r.path = r.path.replace(`:${k}`, r.params[k])
            })
          }
          r.to = { path: r.path }
          return r
        })
        return this.version && routes
      }
    }
  };
</script>

<style scoped></style>
